import { render, staticRenderFns } from "./NlAlert.vue?vue&type=template&id=04dac6ca&"
import script from "./NlAlert.vue?vue&type=script&lang=js&"
export * from "./NlAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports